import connectBreadcrumb from "instantsearch.js/es/connectors/breadcrumb/connectBreadcrumb.js";
import { useConnector } from "../hooks/useConnector.js";
export function useBreadcrumb(props, additionalWidgetProperties) {
  return useConnector(connectBreadcrumb, props, additionalWidgetProperties);
}